import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const { createContext, useState } = require('react');

const AuthContext = createContext();
export const AuthProvider = ({ children }: any) => {
  

    const userData:any = localStorage.getItem("user_data") ? localStorage.getItem("user_data")  : "";
    const user_data:any = !window.cn(userData) ? JSON.parse(userData) : "";
  

    const [token, setToken] = useState(null);
    const [name, setName] = useState(null);
    const [role, setRole] = useState(null);
    const navigate = useNavigate();

    useEffect(()=>{
        setToken(user_data?.token);
        setName(user_data?.first_name);
        setRole(user_data?.role_id);
    },[user_data])


    const saveInformation = (token: any, name: any, role: any) => {
        setToken(user_data?.token);
        setName(user_data?.first_name);
        setRole(user_data?.role);
    };

    const logout = () => {
        setName(null);
        setRole(null);
        setToken(null);
        localStorage.clear();
        navigate("/")
    };

    return (
        <>
            <AuthContext.Provider value={{ token, name, role, saveInformation, logout }}>{children}</AuthContext.Provider>
        </>
    );
};

export default AuthContext;